import {
  ResellerContact,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow"

export default function InstanceResellerTableRow (entry: ResellerContact) {
  const {rs_email: rowEmail, rs_firstname: rowFirst, rs_lastname: rowLast} = entry
  return InstanceContactRow({rowEmail, rowFirst, rowLast})
}